var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"App-buttons"},[_c('button-component',{attrs:{"color":_vm.color,"value":_vm.text,"is-disabled":_vm.isDisabled,"field-id":"questionButton","log-action":"abstain-modal"},on:{"click-abstain-modal":_vm.trackClick}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1d4edaa3","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Questions/QuestionsButton.vue
// module id = cq8+
// module chunks = 1